import { render, staticRenderFns } from "./OCRDesensitizationView.vue?vue&type=template&id=5db58648&scoped=true"
import script from "./OCRDesensitizationView.vue?vue&type=script&lang=js"
export * from "./OCRDesensitizationView.vue?vue&type=script&lang=js"
import style0 from "./OCRDesensitizationView.vue?vue&type=style&index=0&id=5db58648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db58648",
  null
  
)

export default component.exports